import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import CallToAction from "@scentregroup/ui/components/call-to-action";
import Row from "@scentregroup/ui/components/form/row";
import Heading from "@scentregroup/ui/components/heading";
import { getCartItemIssueText } from '@scentregroup/shared/helpers/stock-level-issue-messages';
import { associatePromotionsWithCoupons } from '@scentregroup/shared/helpers/marketplace-promotions';
import { Box } from '@hub/box';
import { Stack } from '@hub/stack';
import { LinkButton } from '@hub/link';
import AnalyticsDataWrapper from '../analytics-data-wrapper';
import OrderSummary from '../order-summary';
import CartProductItem from '../cart-preview-product-item-experiment';
import trackMkpEvents, { labels } from '../../../../apps/checkout/src/client/lib/market-place-track-event';
import { calculateItemCountFromItems, calculateSumWithNoDiscount } from '../../../../apps/checkout/src/client/lib/order-summary';
import useUser from '../../../../apps/checkout/src/client/lib/use-user';
import { makeCheckoutTagging } from '../../../../apps/checkout/src/client/lib/analytics-tagging';
import { useCreateCheckoutAnalytics } from '../../../../apps/checkout/src/client/lib/analytics-checkout-tagging';
import { isMarketplaceCouponEligible } from '../../../../apps/checkout/src/client/lib/marketplace-coupon';
import { makeAnalyticsProductRemovedEventData } from '../../../../apps/checkout/src/client/lib/analytics-cart';
import { useAnalytics } from '../../analytics';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";

// Buttons' data-test-id will have to be updated for e2e tests
const SubmitButtons = _ref => {
  let {
    handleCheckoutClick
  } = _ref;
  const {
    user
  } = useUser();

  if (user) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Row, {
        "data-id": "cart-preview-experiment_index_SubmitButtons_Row",
        children: /*#__PURE__*/_jsx(LinkButton, {
          href: "/shop/cart",
          "data-id": "cart-preview-experiment_index_SubmitButtons_Row_LinkButton",
          children: "View Cart"
        })
      }), /*#__PURE__*/_jsx(Row, {
        "data-id": "cart-preview-experiment_index_SubmitButtons_Row",
        children: /*#__PURE__*/_jsx(CallToAction, {
          "data-test-id": "cart-preview-checkout-btn",
          onClick: () => {
            handleCheckoutClick('straightToCheckout');
            trackMkpEvents.clicked(labels.LOGGED_IN_MEMBER_CHECKOUT);
          },
          "data-id": "cart-preview-experiment_index_SubmitButtons_Row_CallToAction",
          children: "Checkout"
        })
      })]
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Row, {
      "data-id": "cart-preview-experiment_index_SubmitButtons_Row",
      children: /*#__PURE__*/_jsx(LinkButton, {
        href: "/shop/cart",
        "data-id": "cart-preview-experiment_index_SubmitButtons_Row_LinkButton",
        children: "View Cart"
      })
    }), /*#__PURE__*/_jsx(Row, {
      "data-id": "cart-preview-experiment_index_SubmitButtons_Row",
      children: /*#__PURE__*/_jsx(CallToAction, {
        "data-test-id": "cart-checkout-btn-member",
        onClick: () => {
          handleCheckoutClick('viaLogin');
          trackMkpEvents.clicked(labels.MEMBER_CHECKOUT);
        },
        "data-id": "cart-preview-experiment_index_SubmitButtons_Row_CallToAction",
        children: "Checkout"
      })
    })]
  });
};

const CartPreview = _ref2 => {
  let {
    id,
    cartAmount,
    currency,
    cartItems,
    cartCoupons,
    updateCartItemQuantity,
    handleCheckoutClick
  } = _ref2;
  const {
    user
  } = useUser();
  const {
    trackEvent
  } = useAnalytics();
  const productsAnalytics = makeCheckoutTagging(cartItems, user === null || user === void 0 ? void 0 : user.scentregroupId, currency, '1', cartCoupons);
  useCreateCheckoutAnalytics({
    cartId: id,
    items: cartItems,
    currency,
    step: '1',
    scentregroupId: user === null || user === void 0 ? void 0 : user.scentregroupId,
    coupons: cartCoupons
  });
  return /*#__PURE__*/_jsxs(Stack, {
    gap: 'spacing-lg',
    "data-id": "cart-preview-experiment_index_SubmitButtons_Stack",
    children: [productsAnalytics.map((itemAnalytics, i) => /*#__PURE__*/_createElement(AnalyticsDataWrapper, _objectSpread(_objectSpread({}, itemAnalytics), {}, {
      key: i,
      "data-id": "cart-preview-experiment_index_SubmitButtons_AnalyticsDataWrapper"
    }))), /*#__PURE__*/_jsxs(Box, {
      sx: {
        px: 'spacing-md',
        paddingTop: 'spacing-md'
      },
      "data-id": "cart-preview-experiment_index_SubmitButtons_Stack_Box",
      children: [/*#__PURE__*/_jsx(Heading, {
        type: "small",
        className: style.heading,
        "data-id": "cart-preview-experiment_index_SubmitButtons_Box_Heading",
        children: "Items in your cart"
      }), cartItems.map(item => {
        var _item$shop$retailer, _item$promotions, _item$category;

        return /*#__PURE__*/_jsx(CartProductItem, {
          shop: item.shop,
          variantGroupCode: item.variantGroupCode,
          sku: item.sku,
          analyticsData: {
            productId: item.id,
            retailerId: (_item$shop$retailer = item.shop.retailer) === null || _item$shop$retailer === void 0 ? void 0 : _item$shop$retailer.sys.id
          },
          title: item.name,
          productImage: item.image,
          currency: currency,
          price: item.listPrice,
          discountedPrice: item === null || item === void 0 ? void 0 : item.discountPrice,
          applicablePromotions: item.variant.promotions,
          appliedPromotions: associatePromotionsWithCoupons({
            promotions: (_item$promotions = item.promotions) !== null && _item$promotions !== void 0 ? _item$promotions : [],
            coupons: cartCoupons.filter(isMarketplaceCouponEligible)
          }),
          variantText: item.optionValues.map(o => o.value).join(', '),
          category: (_item$category = item.category) === null || _item$category === void 0 ? void 0 : _item$category.path.map(cpe => cpe.title).join('/'),
          brand: item.brand,
          quantity: item.quantity,
          maxQuantity: item.variant.quantity,
          returnable: item.variant.returnable,
          error: getCartItemIssueText(item.issues, item.variant.quantity, true),
          onChangeQuantity: e => updateCartItemQuantity({
            variables: {
              input: {
                cartId: id,
                itemId: item.id,
                quantity: e.value
              }
            }
          }),
          onRemoveClick: () => {
            trackMkpEvents.clicked(labels.REMOVED_ITEM);
            trackEvent({
              type: 'legacy',
              data: makeAnalyticsProductRemovedEventData(item, id)
            });
            return updateCartItemQuantity({
              variables: {
                input: {
                  cartId: id,
                  itemId: item.id,
                  quantity: 0
                }
              }
            });
          },
          "data-id": "cart-preview-experiment_index_SubmitButtons_CartProductItem"
        }, item.id);
      })]
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        backgroundColor: 'smoke',
        padding: 'spacing-md'
      },
      "data-id": "cart-preview-experiment_index_SubmitButtons_Stack_Box",
      children: /*#__PURE__*/_jsx(OrderSummary, {
        displaySubTotalText: true,
        itemCount: calculateItemCountFromItems(cartItems),
        subTotal: calculateSumWithNoDiscount(cartItems),
        fees: [],
        total: cartAmount,
        submitButtons: /*#__PURE__*/_jsx(SubmitButtons, {
          handleCheckoutClick: handleCheckoutClick,
          "data-id": "cart-preview-experiment_index_SubmitButtons"
        }),
        "data-id": "cart-preview-experiment_index_SubmitButtons_Box_OrderSummary"
      })
    })]
  });
};

export default CartPreview;